import { Component, Input } from '@angular/core';

@Component({
    selector: 'lib-version-display',
    imports: [],
    templateUrl: './version-display.component.html',
    styleUrl: './version-display.component.scss'
})
export class VersionDisplayComponent {
	@Input() appVersion: string = '';

	get displayedVersion() {
		return (this.appVersion && `v. ${this.appVersion}`) || '';
	}
}
